export const STATUS_ITEMS = ['Ativo', 'Inativo','Pendente']
export const TIPO_IMOVEL_BULDER_ITEMS = ['Terreno','Galpāo','Prédio']